<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 19.075 21.8">
        <g id="password" transform="translate(-32)">
            <g id="Group_2397" data-name="Group 2397" transform="translate(32)">
                <g id="Group_2396" data-name="Group 2396">
                    <circle id="Ellipse_31" data-name="Ellipse 31" cx="1" cy="1" r="1"
                            transform="translate(11.538 13.9)" fill="#799cfb"/>
                    <path id="Path_69778" data-name="Path 69778"
                          d="M50.224,15.413a.852.852,0,0,0,.852-.852V11.411A3.41,3.41,0,0,0,47.669,8H46.645V5A5.111,5.111,0,0,0,36.427,5V8h-1.02A3.41,3.41,0,0,0,32,11.411v6.983A3.41,3.41,0,0,0,35.406,21.8H47.669a3.41,3.41,0,0,0,3.406-3.406.852.852,0,1,0-1.7,0,1.705,1.705,0,0,1-1.7,1.7H35.406a1.705,1.705,0,0,1-1.7-1.7V11.411a1.705,1.705,0,0,1,1.7-1.7H47.669a1.705,1.705,0,0,1,1.7,1.7v3.151A.852.852,0,0,0,50.224,15.413ZM44.942,8H38.13V5a3.408,3.408,0,0,1,6.813,0Z"
                          transform="translate(-32)" fill="#799cfb"/>
                    <circle id="Ellipse_33" data-name="Ellipse 33" cx="1" cy="1" r="1" transform="translate(4.538 13.9)"
                            fill="#799cfb"/>
                    <circle id="Ellipse_34" data-name="Ellipse 34" cx="1" cy="1" r="1" transform="translate(8.538 13.9)"
                            fill="#799cfb"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "ILock",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
